// TODO source form query string, esIndexParam
// const getEsIndexParam = () => (getEsIndex() ? "?es-index=" + getEsIndex() : "?es-index=PUBLICATION_PRODCOPY");

export const aggregationFields = [
  "language",
  "companies.name.en",
  "companies.name.ja",
  // "analysts.name.en",
  // "analysts.name.ja",
  "assetClasses.en",
  "assetClasses.ja",
  "gicsSectors.ja",
  "gicsSectors.en",
  "gicsIndustryGroups.en",
  "gicsIndustryGroups.ja",
  "periodicals.en",
  "periodicals.ja",
  "reportTitles.en",
  "reportTitles.ja",
  "reportTypes.en",
  "reportTypes.ja",
  "regions.en",
  "regions.ja",
  "themes.en",
  "themes.ja",
  "attributes.priceOrRatingChange.en",
  "attributes.priceOrRatingChange.ja",
  "contentType.en",
  "contentType.ja",
  "txSubCategories.en",
  "txSubCategories.ja",
  "countries.en",
  "countries.ja",
  "currencies.en",
  "currencies.ja",
];

export const analystAggregation = {
  "analysts.name.en": {
    filter: { term: { "analysts.isActive": true } },
    aggs: {
      activeAnalysts: { terms: { field: "analysts.name.en", size: 5 } },
    },
  },
  "analysts.name.ja": {
    filter: { term: { "analysts.isActive": true } },
    aggs: {
      activeAnalysts: { terms: { field: "analysts.name.ja", size: 5 } },
    },
  },
};

export const sourceFields = [
  "analysts",
  "internal",
  "pageCount",
  "regions",
  "id",
  "title",
  "publicationDate",
  "assetClasses",
  "synopsis",
  "gicsIndustryGroups",
  "reportTypes",
  "reportTitles",
  "periodicals",
  "resources",
  "customData.coverImage",
];
